/*
* @描述: 登录页面
* @版本: 1.0
* @作者: 冯强
* @创建时间: 2022-11-23 17:37:29
*/
<template>
    <div class="login_page">
        <div class="login_wrap">
            <div class="left_intro_wrap">
                <h1 class="mb-15">[ 澜精灵ERP系统 ]</h1>
                <h4 class="mb-15">欢迎使用澜精灵ERP系统</h4>
                <ul class="mb-15">
                    <li class="intro_item">
                        <i class="el-icon-right"></i>
                        <span>高整合, 高弹性, 集中数据存储</span>
                    </li>
                    <li class="intro_item">
                        <i class="el-icon-right"></i>
                        <span>直观, 简洁的数据统计</span>
                    </li>
                    <li class="intro_item">
                        <i class="el-icon-right"></i>
                        <span>卓越, 创新, 精益求精</span>
                    </li>
                </ul>
<!--                <div>-->
<!--                    <span>还没有账号？</span>-->
<!--                    <el-button type="text" size="small" @click="$router.push('/register')">-->
<!--                        立即注册<i class="el-icon-d-arrow-right"></i>-->
<!--                    </el-button>-->
<!--                </div>-->
            </div>
            <div class="login_form_wrap">
                <el-tabs v-model="loginType" @tab-click="handleClickTab">
                    <el-tab-pane label="账号密码登录" name="account"></el-tab-pane>
<!--                    <el-tab-pane label="验证码登录" name="code"></el-tab-pane>-->
<!--                    <el-tab-pane label="微信登录" name="wechat">-->
<!--                        <div class="qr_code_wrap">-->
<!--                            <img src="https://open.weixin.qq.com/connect/qrcode/081rITTn0BY6Ga1b" alt="">-->
<!--                        </div>-->
<!--                        <div class="code_text">使用微信扫一扫快速登录</div>-->
<!--                    </el-tab-pane>-->
                </el-tabs>
                <el-form :model="loginForm"
                         :rules="loginFormRules"
                         ref="loginForm"
                         @keyup.enter.native="handleClickLogin"
                         v-if="loginType==='code'||loginType==='account'">
                    <el-form-item prop="phone">
                        <el-input v-model="loginForm.phone" placeholder="请输入手机号"></el-input>
                    </el-form-item>
                    <el-form-item prop="code" v-if="loginType==='code'">
                        <div class="code_wrap">
                            <el-input maxlength="6"
                                      v-model="loginForm.code"
                                      onkeyup="value=value.replace(/[^\d]/g,'')"
                                      placeholder="请输入验证码">
                            </el-input>
                            <el-button type="primary"
                                       :disabled="timer"
                                       @click="handleClickSendCode"
                                       v-text="sendCodeText">
                            </el-button>
                        </div>
                    </el-form-item>
                    <div v-if="loginType==='account'">
                        <el-form-item prop="password">
                            <el-input v-model="loginForm.password" placeholder="请输入密码" show-password></el-input>
                        </el-form-item>
<!--                        <el-button type="text">忘记密码？</el-button>-->
                    </div>
                    <el-button style="width: 100%" type="primary" @click="handleClickLogin">登 录</el-button>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
import { AccountLogin, PhoneLogin, SendCode } from '@/api'
import {merchantAccount} from '@/utils/index'

export default {
    name: 'Login',
    data () {
        //手机号校验规则
        const validatorPhone = (rule, value, callback) => {
            if (value) {
                const phone = value.replace(/\s/g, '')
                let regs = /^1[3456789]\d{9}$/
                if (regs.test(phone)) {
                    callback()
                } else {
                    callback(new Error('请输入正确的手机号'))
                }
            } else {
                callback(new Error('请输入手机号'))
            }
        }
        return {
            loginForm: { //登录表单
                phone: '', //手机号
                code: '', //验证码
                password: '', //密码
            },
            loginFormRules: { //登录表单校验规则
                phone: [{
                    type: 'number',
                    required: true,
                    validator: validatorPhone,
                    trigger: 'blur',
                }],
                code: [{
                    required: true,
                    message: '请输入验证码',
                    trigger: ['blur', 'change']
                }],
                password: [{
                    required: true,
                    message: '请输入密码',
                    trigger: ['blur', 'change']
                }],
            },
            loginType: 'account', //登录方式：account:用户名密码, code:验证码, wechat: 微信登录
            sendCodeText: '发送验证码', // 验证码按钮显示文字
            countDown: 60, //倒计时
            timer: null, //计时器
        }
    },
    created () {
    },
    mounted () {
    },
    methods: {
        //点击发送验证码事件
        handleClickSendCode () {
            //先单独校验手机号
            this.$refs.loginForm.validateField('phone', valid => {
                if (!valid) {
                    //开启倒计时
                    this.timer = setInterval(() => {
                        //开始倒计时并修改按钮文字
                        this.countDown--
                        this.sendCodeText = `已发送（${this.countDown}）`
                        if (this.countDown < 1) {
                            //倒计时等于0时清除定时器
                            clearInterval(this.timer)
                            //修改验证码按钮文字
                            this.sendCodeText = '重新发送'
                            //倒计时归60
                            this.countDown = 60
                        }
                    }, 1000)
                    //手机号校验通过后发请求发送验证码
                    SendCode({
                        phone: this.loginForm.phone,
                        scene: 'login',
                    }).then(res => {
                        if (res.code === 200) {
                            this.$message.success('发送成功')
                        } else {
                            clearInterval(this.timer)
                        }
                    })
                } else {
                    return false
                }
            })
        },

        //点击登录事件
        handleClickLogin () {
          //表单校验
            this.$refs.loginForm.validate(valid => {
                if (valid) {
                    if (this.loginType === 'code') {
                        //校验通过,发送手机号登录请求
                        PhoneLogin({
                            phone: this.loginForm.phone,
                            code: this.loginForm.code,
                        }).then(res => {
                            if (res.code === 200) {
                                this.loginSuccess(res.data)
                            }
                        })
                    } else if (this.loginType === 'account') {
                        AccountLogin({
                            phone:this.loginForm.phone,
                            password: this.loginForm.password
                        }).then(res=>{
                            if(res.code === 200){
                                this.loginSuccess(res.data)
                            }
                        })
                    }
                } else {
                    return false
                }
            })
        },

        //登录成功
        loginSuccess (userInfo) {
          this.$message.success('登录成功')
          //保存token到vuex中
          this.$store.dispatch('saveUserInfo', userInfo)
          if(merchantAccount.indexOf(userInfo.phone) > -1){
            this.$router.replace('/system/basic_information')
          }else{
            //跳转到首页
            this.$router.replace('/system/treeNode')
          }


        },

        //点击切换标签事件
        handleClickTab (tab, event) {
            if (this.$refs.loginForm) {
                //切换时清空表单内容和校验结果
                this.$refs.loginForm.resetFields()
            }
            //如果登录方式为微信登录
            if (tab.name === 'wechat') {
                // 请求接口获取二维码
            }
        }
    },
}
</script>
<style lang="scss" scoped>
.login_page {
    width: 100%;
    height: 100%;
    background: url("../../assets/img/login_bg.jpg") center no-repeat ;
  background-size: cover;
    box-sizing: border-box;
    padding-top: 10%;

    .login_wrap {
        width: 800px;
        margin: 0 auto;
        color: #ffffff;
        display: flex;
        justify-content: space-between;

        .left_intro_wrap {
            width: 55%;

            .intro_item {
                margin-bottom: 5px;
            }

            .el-icon-right {
                border: 1px solid #ffffff;
                border-radius: 50%;
                margin-right: 5px;
            }
        }

        .login_form_wrap {
            width: 45%;
            min-width: 360px;
            background: rgba(255, 255, 255, .2);
            border: 1px solid rgba(255, 255, 255, .3);
            box-shadow: 0 3px 0 rgb(12 12 12 / 3%);
            padding: 30px;
            border-radius: 3px;
            box-sizing: border-box;

            ::v-deep.el-tabs__item{
                color: #ffffff;
            }
			::v-deep.el-tabs__item.is-active{
			    color: #1990FF
			}


            .code_wrap {
                position: relative;

                .el-button {
                    position: absolute;
                    right: 0;
                }
            }

            .other_login_way {
                img {
                    margin-left: 15px;
                    vertical-align: middle;
                    cursor: pointer;
                }
            }

            .qr_code_wrap {
                width: 180px;
                height: 180px;
                margin: 0 auto 15px;
                border: 1px solid #EEEEEE;

                img {
                    width: 100%;
                }
            }

            .code_text {
                width: 100%;
                text-align: center;
            }
        }
    }
}

@media only screen and (max-width: 800px) {
    .login_wrap {
        display: block !important;

        .left_intro_wrap, .login_form_wrap {
            width: 45% !important;
            margin: 0 auto;
        }
    }
}
</style>
